module.exports = __webpack_public_path__ + "static/media/20a-03.69a32de3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20a/20a-03.jpg
// module id = 244
// module chunks = 0